"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenEventLabel = void 0;
var OpenEventLabel;
(function (OpenEventLabel) {
    OpenEventLabel["MY_PROFILE"] = "My Profile";
    OpenEventLabel["SETTINGS"] = "Settings";
    OpenEventLabel["MY_WISHLIST"] = "My wishlist";
    OpenEventLabel["MY_ORDERS"] = "My orders";
    OpenEventLabel["REDEEM_YOUR_VOUCHER"] = "Redeem your voucher";
    OpenEventLabel["VOUCHER_VALIDITY"] = "Voucher validity";
    OpenEventLabel["OPTIONS_DROPDOWN"] = "OptionsDropdown";
})(OpenEventLabel || (exports.OpenEventLabel = OpenEventLabel = {}));
//# sourceMappingURL=MobileOpenEventLabel.js.map